/**
 * Очищает куки поиска для всех доменов (основной домен и поддомены)
 * Используется при переключении региона, чтобы избежать дубликатов
 */
export const clearSearchCookies = (): void => {
	const searchCookies = ['NBC_SEARCH_FIND_LIST', 'NBC_SEARCH_HISTORY_LIST']
	const pastDate = new Date(0).toUTCString()

	searchCookies.forEach(cookieName => {
		// Удаляем куку с доменом .iport.ru (общая для всех поддоменов)
		document.cookie = `${cookieName}=; path=/; domain=.iport.ru; expires=${pastDate}`
		// Удаляем куку без домена (для текущего поддомена)
		document.cookie = `${cookieName}=; path=/; expires=${pastDate}`
	})
}

/**
 * Очищает куки региона для всех доменов (основной домен и поддомены)
 * Используется при переключении региона, чтобы избежать дубликатов и конфликтов
 * Примечание: HttpOnly куки удаляются только сервером при следующем запросе
 */
export const clearRegionCookies = (): void => {
	const regionCookies = ['CITY_CODE', 'CITY_NAME']
	const pastDate = new Date(0).toUTCString()

	regionCookies.forEach(cookieName => {
		// Удаляем обычные куки (без HttpOnly)
		document.cookie = `${cookieName}=; path=/; domain=.iport.ru; expires=${pastDate}`
		document.cookie = `${cookieName}=; path=/; expires=${pastDate}`
	})
}
